import URLUtils from '@/shared/utils/URLUtils';
import { openThirdPage } from '@/api/native/utils';
import { MembersRightsPrefix } from '@/constant';
import { RightPackageTypeEnum } from '@/api/rights/types';

export const goBindBankCard = (
  from: string,
  scene: string,
  packageId: string,
  bindCardApplySessionId: string,
  packageType: RightPackageTypeEnum,
): void => {
  const url = URLUtils.formatUrl(`${MembersRightsPrefix}bind-bank-card.html#/bind-bank-card`,
    {
      bindCardApplySessionId,
      from,
      scene,
      packageId,
      packageType,
    });
  openThirdPage(url);
};
